import { ContentState } from 'draft-js';
import React from 'react';

export interface RichEditorVariable {
    name: string[] | string;
    displayText?: string;
    value?: string;
}

// DraftDecoratorComponentProps exists in 'draft-js' but it's not exposed
// in @types/draft-js (even though it's there in the flow definitions)
// Manually recreating the type here.
export interface DraftDecoratorComponentProps {
    blockKey: string;
    children?: React.ReactChildren;
    contentState: ContentState;
    decoratedText: string;
    end: number;
    entityKey?: string;
    offsetKey: string;
    start: number;
}

export interface TriggerRange {
    text: string;
    start: number;
    end: number;
    blockKey: string;
}

export enum KeyCommands {
    AutoCompleteClose = 'autocomplete-close',
    AutoCompleteNext = 'autocomplete-next',
    AutoCompletePrevious = 'autocomplete-previous',
    AutoCompleteSelect = 'autocomplete-select',
    ToolbarBold = 'toolbar-bold',
    ToolbarItalic = 'toolbar-italic',
    ToolbarUnderline = 'toolbar-underline',
    ToolbarBulletedList = 'toolbar-bulletedlist',
    ToolbarNumberedList = 'toolbar-numberedlist',
    ToolbarLink = 'toolbar-link',
}

export enum EntityTypes {
    Link = 'LINK',
    Variable = 'VARIABLE',
}

export enum ToolbarButtons {
    BOLD = 'bold',
    ITALIC = 'italic',
    UNDERLINE = 'underline',
    BULLETED_LIST = 'bulleted-list',
    NUMBERED_LIST = 'numbered-list',
    LINK = 'link',
}
